// extracted by mini-css-extract-plugin
module.exports = {"pickerWrapper":"indicators-bar_pickerWrapper__I7Wsb"};